import { ICalculationInfo } from '../../../../redux/Calculations/CurrentCalculationSessionInterface';

export const isAggregationCalculation = (
  calcInfo: ICalculationInfo,
  finalFlow: string,
): boolean => {
  return calcInfo.flows[finalFlow][0]?.isAggregation === true;
};
